module.exports = __webpack_public_path__ + "static/media/v2.5b9add00.mp4";